import { forAllCallback } from "kwp-core/scripts/utils/helpers";

export default () => {
    forAllCallback(".content-block.content-block--events", (el) => {
        console.log(el);
    });
};
